import BasePage from './BasePage';

export default class FragmentPage extends BasePage {
  constructor(id, meta, options = {}) {
    super(id, meta);
    this.contentFile = options.contentFile || `${id}.html`;
    this.contentUrl = `pages/${this.contentFile}`;
    this.cachedHtml = null;
  }

  async loadContent() {
    if (this.cachedHtml !== null) {
      return this.cachedHtml;
    }

    const response = await fetch(this.contentUrl, { cache: 'no-store' });
    if (!response.ok) {
      throw new Error(`Unable to load page content: ${this.contentUrl}`);
    }
    this.cachedHtml = await response.text();
    return this.cachedHtml;
  }

  async render(context) {
    await super.render(context);
    const html = await this.loadContent();
    context.content.innerHTML = html;
  }
}
